import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const vuetify = new Vuetify({
	theme: {
    themes: {
      light: {
        primary: "#4caf50",
      },
    },
  },
});

export default vuetify;